import { client } from "api";
import { Company } from "models/Company";
import { CompanyComment } from "models/CompanyComment";

export type UpdateCommentRequest = { companyId: Company["id"] } & Pick<CompanyComment, "id" | "commentText" | "important">;

export type UpdateCommentResponse = CompanyComment[];

export const updateComment = ({ companyId, id, commentText, important }: UpdateCommentRequest) =>
  client.put<UpdateCommentResponse>(`/company/${companyId}/comments/${id}`, { commentText, important }).then((res) => res.data);
